export { default as AttachToContactScreen } from "./AttachToContact";
export { default as AttachToJournalScreen } from "./AttachToJournal";
export { default as AttachToTreatmentScreen } from "./AttachToTreatment";
export { default as QuestionMainScreen } from "./QuestionMainScreen";
export { default as QuestionsScreen } from "./QuestionsScreen";
